<template>
    <div class="RiskProfileTable">
        <Table>
            <template #head>
                <HeadCell class="RiskProfileTable__nameHeader">
                    Risk Profile
                </HeadCell>
                <HeadCell class="RiskProfileTable__assignmentHeader">
                    Assignment
                </HeadCell>
                <HeadCell class="RiskProfileTable__profileTypeHeader">
                    Type
                </HeadCell>
                <HeadCell class="RiskProfileTable__numberOfRequirementsHeader">
                    Requirements
                </HeadCell>
                <HeadCell class="RiskProfileTable__statusHeader">
                    Status
                </HeadCell>
                <HeadCell class="RiskProfileTable__actionsHeader" />
            </template>

            <template #toolbarEnd>
                <RbacDisplayGuard :features="[RbacFeature.decisioningCreateRiskProfile]">
                    <NewButton
                        class="RiskProfileTable__addRiskProfileButton"
                        color="primary"
                        @click="$emit('create')"
                    >
                        <EidIcon :icon-src="faPlus" />
                        Add New Risk Profile
                    </NewButton>
                </RbacDisplayGuard>
            </template>
            <RiskProfileTableRow
                v-for="riskProfile of riskProfiles"
                :key="riskProfile.id"
                :risk-profile="riskProfile"
                :show-risk-profile-type-icon="isCollateralEnabled"
                v-bind="$attrs"
            />
        </Table>
    </div>
</template>

<style lang="scss" scoped>
.RiskProfileTable {
    height: 100%;

    &__numberOfRequirementsHeader {
        display: flex;
        justify-content: center;
    }
}
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { faPlus } from '@fortawesome/pro-light-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { HeadCell, Table } from '@evidentid/dashboard-commons/components/Table';
    import RbacDisplayGuard from '@evidentid/dashboard-commons/modules/role-base-access-control/components/rbac-guard/RbacDisplayGuard.vue';
    import { RiskProfile } from '@evidentid/tprm-portal-lib/models/decisioning/RiskProfile.model';
    import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

    import NewButton from '@/components/new-button/NewButton.vue';
    import RiskProfileTableRow
        from '@/modules/decisioning-criteria/components/RiskProfileTableRow/RiskProfileTableRow.vue';

    @Component({
        emits: [ 'create' ],
        components: {
            EidIcon, NewButton, HeadCell, RbacDisplayGuard, RiskProfileTableRow, Table,
        },
    })
    export default class RiskProfileTable extends Vue {
        @Prop({ type: Array, default: () => [] })
        private riskProfiles!: RiskProfile[];

        // Make RbacFeature available in template
        private RbacFeature = RbacFeature;
        private faPlus = faPlus;

        private get isCollateralEnabled(): boolean {
            return this.$rp.currentDetails?.collateralsEnabled || false;
        }
    }
</script>
